import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Class } from '../data/class';

@Component({
  selector: 'app-csv-buttons',
  templateUrl: './csv-buttons.component.html',
  styleUrls: ['./csv-buttons.component.scss']
})
export class CsvButtonsComponent implements OnInit {
  @Input() onValidate: (row: any) => string;
  onImportRow: (row: any) => Promise<void>;
  @Output() ImportRow = new EventEmitter<{ row: any, promise: Promise<void> }>();
  @Input() columnDefinitions: { name: string, isRequired: boolean, validate?: (value: any) => string }[];
  @Input() tooManyErrors = 5;
  showInput: boolean = false;
  fileInput: string;
  csvFile: FileList;
  class: Class;
  validationErrors: string[];
  importErrors: string[];
  rows: any[] = [];
  processedRows = 0;
  importHeaders = false;
  next = false;

  ngOnInit() {

  }

  clicked(): void {
    this.showInput = true;
  }

  nextClicked(): void {
    this.next = true;
  }

  closeWindow(): void {
    this.showInput = false;
    this.next = false;
  }

  parseRow(text: string, offset: number): { data: string[], newOffset: number } {
    var cellData = "";
    var rowData: string[] = [];

    let cellDone = function (): void {
      rowData.push(cellData.trim());
      cellData = "";
    }

    while (offset < text.length) {
      switch (text[offset]) {
        case '\\':
          if (text[offset + 1] === '\\') {
            cellData = cellData + '\\';
            ++offset;
          } else if (text[offset + 1] === ',') {
            cellData = cellData + ',';
            ++offset;
          } else {
            throw ("Escaped \\ character must be folowed by a \\ or ,")
          }
          break;
        case ',':
          cellDone();
          break;
        case '\n':
          cellDone();
          return { data: rowData, newOffset: offset + 1 };
        default:
          cellData = cellData + text[offset];
          break;
      }
      ++offset;
    }
    cellDone();
    return { data: rowData, newOffset: offset };
  }

  parseRows(text: string, offset: number, columnNames: string[], rowParsed: (row: any) => any): void {
    while (offset < text.length) {
      var rowResult = this.parseRow(text, offset);
      if (rowResult.data.length > 0) {
        rowParsed(rowResult.data.reduce((p, c, i) => { p[columnNames[i]] = c; return p; }, {}));
      }
      offset = rowResult.newOffset;
    }
  }

  parseHeaders(text: string): { columnNames: string[], endingOffset: number } {
    var result = this.parseRow(text, 0);
    return { columnNames: result.data, endingOffset: result.newOffset };
  }

  onFileLoad = (fileLoadedEvent) => {
    const textFromFileLoaded = fileLoadedEvent.target.result;
    var offset = 0;
    var columnNames = this.columnDefinitions.map(cd => cd.name);
    if (this.importHeaders) {
      var headerResult = this.parseHeaders(textFromFileLoaded);
      offset = headerResult.endingOffset;
      columnNames = headerResult.columnNames;
    }
    this.rows = [];
    this.processedRows = 0;
    this.parseRows(textFromFileLoaded, offset, columnNames, (r) => {
      this.rows.push(r);
    });
    this.validationErrors = this.validateResults(this.rows, this.onValidate ? this.onValidate : r => CsvButtonsComponent.validateRow(r, this.columnDefinitions));
  }

  onProcess() {
    if (this.validationErrors.length === 0) {
      this.rows.map((e) => {
        this.ImportRow.emit(e);
      })
    }
  }

  onFileSelect(input: FileList) {
    this.csvFile = input;
    const files = this.csvFile.item(0);
    const fileReader = new FileReader();

    fileReader.onload = this.onFileLoad;
    fileReader.readAsText(files);
  }

  validateResults(rows: any[], validateRow: (any) => string): string[] {
    var errors = [];
    for (let i = 0; i < rows.length; ++i) {
      let result = validateRow(rows[i]);
      if (result !== null) {
        errors.push(result);
      }
    }
    return errors;
  }

  importRows(rows: any[]) {
    this.importErrors = [];
    this.processedRows = 0;
    if (this.onImportRow && this.importErrors.length < this.tooManyErrors && this.processedRows < rows.length) {
      this.onImportRow(rows[this.processedRows]).then(() => {
        this.processedRows++;
        this.importRows(rows);
      }).catch(e => {
        this.processedRows++;
        this.importErrors.push(e);
        this.importRows(rows);
      });
    }
  }

  public static validateRow(row: any, columnDefinitions: { name: string, isRequired: boolean, validate?: (value: any) => string }[]): string {
    var tooValidate = columnDefinitions.slice();
    for (var field in row) {
      var ruleIndex = tooValidate.findIndex(r => r.name === field);
      if (ruleIndex < 0) {
        return "Field " + field + " was not expected.";
      }
      else if (tooValidate[ruleIndex].validate) {
        var result = tooValidate[ruleIndex].validate(row[field]);
        if (result) {
          return result;
        }
      }
      tooValidate.splice(ruleIndex, 1);
    };
    var missing = tooValidate.filter(r => r.isRequired);
    if (missing.length > 0) {
      return "The following required fields are missing: " + tooValidate.map(r => r.name).reduce((p, c) => (p ? p + ", " : "") + c);
    }
    return null;
  }
}
